import * as React from "react";
import RemoderationActivityRow from "~/components/Remoderation/RemoderationActivityRow";
import styled from "~/styled";

const Wrapper = styled.div`
  display: grid;
  font-size: 10px;
`;

const Table = styled.table`
  thead th,
  tbody td {
    text-align: right;
  }
`;

interface IState {
  interval?: NodeJS.Timer;
  moderationActivity: {
    [key: string]:
      | {
          skip: number;
          delete: number;
          delete_remoderation: number;
          submit: number;
          submit_remoderation: number;
        }
      | undefined;
  };
}

export default class RemoderationActivityContainer extends React.Component<
  {},
  IState
> {
  public readonly state: IState = {
    moderationActivity: {}
  };

  public render() {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const day = new Date().getDate();

    const monthKey = `${year}-${month}`;
    const dayKey = `${year}-${month}-${day}`;

    const monthData = this.state.moderationActivity[monthKey];
    const dayData = this.state.moderationActivity[dayKey];

    return (
      <Wrapper>
        <Table>
          <thead>
            <tr>
              <th>Activity</th>
              <th>Submitted</th>
              <th>Deleted</th>
            </tr>
          </thead>
          <tbody>
            {dayData && <RemoderationActivityRow title="Today" {...dayData} />}
            {monthData && (
              <RemoderationActivityRow title="This month" {...monthData} />
            )}
          </tbody>
        </Table>
      </Wrapper>
    );
  }

  public componentDidMount() {
    this.updateActivity();

    const interval = setInterval(() => {
      this.updateActivity();
    }, 1000);

    this.setState({ interval });
  }

  public componentWillUnmount() {
    if (this.state.interval) {
      clearInterval(this.state.interval);
      this.setState({ interval: undefined });
    }
  }

  public updateActivity() {
    const moderationActivityJSON = localStorage.getItem("moderation_activity");

    if (!moderationActivityJSON) {
      // tslint:disable-next-line:no-console
      console.warn("Unable to get moderation activity JSON");
      return;
    }

    this.setState({
      moderationActivity: JSON.parse(moderationActivityJSON)
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/RemoderationActivityContainer.tsx